import { render, staticRenderFns } from "./EmmitedNotificationList.vue?vue&type=template&id=32039fd8&"
import script from "./EmmitedNotificationList.vue?vue&type=script&lang=js&"
export * from "./EmmitedNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports